module.exports = __webpack_public_path__ + "img/angular.b5066f16.jpg";